import { lazy } from "react";
import Loadable from "components/Loadable";
import { FormatConstants, routeConstants } from "services/keyConstants";
import { getStatusTypes } from "./service";
import {
  customerServiceDownload,
  customerServiceList,
} from "api/module/customerService";
import { getMasterDocDataByKey } from "services/ReduxUtils";
import EditIcon from "@mui/icons-material/Edit";

// Lazy-loaded components
const ServiceRecordNew = Loadable(lazy(() => import("../ServiceRecordNew")));
const ServicingForm = Loadable(lazy(() => import("../ServicingForm")));
const RecordView = Loadable(lazy(() => import("../RecordView")));
const CustomerServicingFormDemo = Loadable(
  lazy(() => import("../CustomerServicingFormDemo"))
);
const CommonDetail = Loadable(
  lazy(() => import("components/CommonDetail/CommonDetail"))
);

const ServicingRoutes = [
  {
    path: routeConstants.CUSTOMER_SERVICE,
    children: [
      {
        path: "view/:id",
        element: <RecordView />,
      },
      {
        path: "detail/:id",
        element: (
          <CommonDetail
            navigateRoute={{
              isCondition: false,
              url: (item, filterData) => {
                let complaintMasterDocId = getMasterDocDataByKey({
                  defaultName:
                    FormatConstants.COMPLAINT.CUSTOMER_COMPLAINT_FORM,
                })?.masterDocId;
                return complaintMasterDocId === filterData.current?.status
                  ? `/customer-complaints/customerComplaint?id=${item?._id}`
                  : `/${routeConstants.CUSTOMER_SERVICE}/view/${item?._id}`;
              },
            }}
            url={{
              GET: customerServiceList,
              DOWNLOAD: customerServiceDownload,
            }}
            getStatusTypes={getStatusTypes}
            filterOptions={{
              [FormatConstants.CUSTOMERSERVICE.CUSTOMER_SERVICING_DETAILS]: [
                {
                  name: "Status",
                  optionsKey: "statusOptions",
                  isHiddenAll: true,
                },
                { name: "Type", optionsKey: "typeOptions", isHiddenAll: true },
              ],
              [FormatConstants.CUSTOMERSERVICE.CUSTOMER_SERVICING_FORM]: [
                {
                  name: "Type",
                  optionsKey: "typeOptions",
                  isHiddenAll: true,
                },
              ],
              [FormatConstants.CUSTOMERSERVICE.CUSTOMER_SERVICING_FEEDBACK]: [
                {
                  name: "Type",
                  optionsKey: "typeOptions",
                  isHiddenAll: true,
                },
              ],
            }}
            tableConfig={(item, filterData) => {
              let complaintMasterDocId = getMasterDocDataByKey({
                defaultName: FormatConstants.COMPLAINT.CUSTOMER_COMPLAINT_FORM,
              })?.masterDocId;
              return {
                downloadActionConfig: {
                  isVisible: (row) => {
                    if (
                      complaintMasterDocId === filterData.current?.status &&
                      row?.servicingId === undefined
                    ) {
                      return false;
                    }
                    return true;
                  },
                },
                viewActionConfig: {
                  isVisible: (row) => {
                    if (
                      complaintMasterDocId === filterData.current?.status &&
                      row?.servicingId === undefined
                    ) {
                      return false;
                    }
                    return true;
                  },
                },
                defaultActions: [
                  {
                    tooltip: "Fill The Record",
                    color: "primary",
                    icon: <EditIcon />,
                    isVisible: (row) => {
                      return complaintMasterDocId !== filterData.current?.status
                        ? false
                        : row?.servicingId === undefined;
                    },
                    isCustomRoute: true,
                    getRoute: (row) => {
                      return `../customer-service-form?customerServicingId=${row?._id}`;
                    },
                  },
                ],
                chip: {
                  serviceType: ({ row }) => {
                    let color =
                      row?.serviceType === "initiated"
                        ? "primary"
                        : row?.serviceType === "Internal"
                        ? "success"
                        : "warning";

                    return {
                      label: row?.serviceType,
                      color,
                    };
                  },
                },
              };
            }}
          />
        ),
      },
      {
        path: "service-record/:parentId/:id",
        element: <ServiceRecordNew />,
      },
      {
        path: "service-form",
        element: <ServicingForm />,
      },
      {
        path: "customer-service-form",
        element: <CustomerServicingFormDemo />,
      },
    ],
  },
];

export default ServicingRoutes;
